import { c as _c } from "react/compiler-runtime";
import { useShouldShowBulkAction } from "@hooks/table/use-should-show-bulk-action";
import { BulkChangeSnapshotsAccessLevel } from "@pages/project-details/project-snapshots/bulk-actions/bulk-change-snapshots-access-level";
import { BulkDeleteSnapshots } from "@pages/project-details/project-snapshots/bulk-actions/bulk-delete-snapshots";
import { BulkExportSnapshots } from "@pages/project-details/project-snapshots/bulk-actions/bulk-export-snapshots";
import { isFetchingProjectSnapshotsSelector, selectedProjectSelector } from "@store/projects/projects-selector";
import { useAppSelector } from "@store/store-helper";
import { selectedEntitiesSelector } from "@store/table/table-selector";
import { useMemo } from "react";
/** List all the bulk action components for project snapshots table */
export function useSnapshotBulkActions(t0) {
  const $ = _c(22);
  const {
    snapshots
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = selectedEntitiesSelector("snapshots");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const selectedSnapshots = useAppSelector(t1);
  const selectedProject = useAppSelector(selectedProjectSelector);
  const isFetchingSnapshots = useAppSelector(isFetchingProjectSnapshotsSelector);
  const isAnyRowSelected = selectedSnapshots.length !== 0;
  let allowedButtons;
  if ($[1] !== isAnyRowSelected) {
    allowedButtons = ["export"];
    if (isAnyRowSelected) {
      allowedButtons.push("deleteSnapshots");
      allowedButtons.push("changeSnapshotAccessLevel");
    }
    $[1] = isAnyRowSelected;
    $[2] = allowedButtons;
  } else {
    allowedButtons = $[2];
  }
  const allowedButtonsBasedOnRowSelection = allowedButtons;
  let t2;
  if ($[3] !== allowedButtonsBasedOnRowSelection) {
    t2 = {
      allowedButtonsBasedOnRowSelection
    };
    $[3] = allowedButtonsBasedOnRowSelection;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    shouldShowBulkButtons
  } = useShouldShowBulkAction(t2);
  const snapshotsToExport = isAnyRowSelected ? selectedSnapshots : snapshots;
  let t3;
  if ($[5] !== isFetchingSnapshots || $[6] !== shouldShowBulkButtons || $[7] !== snapshotsToExport) {
    t3 = shouldShowBulkButtons("export") && !isFetchingSnapshots && snapshotsToExport.length > 0;
    $[5] = isFetchingSnapshots;
    $[6] = shouldShowBulkButtons;
    $[7] = snapshotsToExport;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const shouldShowExportButton = t3;
  let t4;
  if ($[9] !== isAnyRowSelected || $[10] !== selectedProject?.name || $[11] !== shouldShowExportButton || $[12] !== snapshotsToExport) {
    t4 = shouldShowExportButton ? <BulkExportSnapshots selectedSnapshots={snapshotsToExport} projectName={selectedProject?.name ?? ""} areEntitiesSelected={isAnyRowSelected} /> : null;
    $[9] = isAnyRowSelected;
    $[10] = selectedProject?.name;
    $[11] = shouldShowExportButton;
    $[12] = snapshotsToExport;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== shouldShowBulkButtons) {
    t5 = shouldShowBulkButtons("deleteSnapshots") ? <BulkDeleteSnapshots /> : null;
    $[14] = shouldShowBulkButtons;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== shouldShowBulkButtons) {
    t6 = shouldShowBulkButtons("changeSnapshotAccessLevel") ? <BulkChangeSnapshotsAccessLevel /> : null;
    $[16] = shouldShowBulkButtons;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6) {
    t7 = {
      export: t4,
      deleteSnapshots: t5,
      changeSnapshotAccessLevel: t6
    };
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}